import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function bgChangeFunction() {
	if($(".wp-block-thefuturblocks-bg-change").length) {
		$(".wp-block-thefuturblocks-bg-change").each(function() {
			var self = $(this),
				dataVal = self.attr("data-bg"),
				body = $('.o-main-container');
			if(!dataVal) return;
		    var tl = gsap.timeline()
		    .to(body,{duration:0.5,backgroundColor:dataVal,ease:"none"});
			var st = ScrollTrigger.create({
				trigger: self,
				start: "top center",
				end: "bottom center",
    			toggleActions: "play reverse play reverse",
				animation: tl
			});
		    
		});
	}
}

$(window).on('load', () => {
  if($('.c-loader').length) {
    gsap.delayedCall(4, function() {
      bgChangeFunction();
    })
  } else {
    gsap.delayedCall(0.4, function() {
      bgChangeFunction();
    })
  }
})